export default __webpack_public_path__ + "a8fb6127ffc6be59485715c1b41a255b.png";